
<form [formGroup]="areaofimpactForm">
<div class="toggle_view">
    <mat-button-toggle-group
  name="fontStyle"
  aria-label="Font Style"
  color="accent"
  class="m-3"
  
  >
  <mat-button-toggle value="list" color="accent" (click)="onList()"
    ><mat-icon class="example-tab-icon"
      >list</mat-icon
    ></mat-button-toggle
  >
  <mat-button-toggle value="grid" (click)="onGrid()"
    ><mat-icon class="example-tab-icon"
      >view_module</mat-icon
    ></mat-button-toggle
  >
  </mat-button-toggle-group>
  </div>
<div class="contents">
   
    <div class="area_of_impact">
        <div class="form_input">
          <h2 class="heading">Area of Impact</h2>

          <div class="form">
            <div class="input">
              <label for="">Party</label>
              <select class="default_input" placeholder="Select Party" formControlName="PartyId" >
                  <option value="">select option</option>
                  <option *ngFor="let partyitem of partys" [value]="partyitem.id">{{partyitem.PartyName}}</option>
                  </select>
             
            </div>
            <div class="input">
              <label for="">Terrian</label>
              <select class="default_input" placeholder="Select Terrain" formControlName="TerrainId" >
                  <option value="">select option</option>
                  <option *ngFor="let terrainitem of terrains" [value]="terrainitem.id">{{terrainitem.TerrainName}}</option>
                  </select>
            
            </div>
            <div class="input">
              <label for="">Net Area</label>
              <input type="number" class="default_input" formControlName="Area"  />
            </div>

            <div class="input">
              <label for="">UOM</label>
              <select class="default_input" placeholder="Select Uom" formControlName="UomId" >
                  <option value="">select option</option>
                  <option *ngFor="let unitofmeasure of uoms" [value]="unitofmeasure.id">{{unitofmeasure.UomName}}</option>
                  </select>
             
            </div>

            <div class="input">
              <label for="">Remark</label>
              <textarea class="default_input" name="" id="" cols="30" rows="5"  formControlName="Remarks"></textarea>
            </div>
          </div>
         
          <div class="btn_holder">
              <button class="default_primary-button" *ngIf="selectedIndex === null" (click)="addAreaOfImpact(areaofimpactForm.value)">Add</button>
              <button class="default_primary-button" *ngIf="selectedIndex !== null" (click)="addAreaOfImpact(areaofimpactForm.value)">Update</button>
              <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
      
            </div>
        </div>

        <div class="enteries" *ngIf="listView">
          <div class="the_table">
            <div class="the_head">
              <span class="head_item">S/N</span>
              <span class="head_item">Party</span>
              <span class="head_item">Terrian</span>
              <span class="head_item">Net Area</span>
              <span class="head_item">UOM</span>
              <span class="head_item">Remark</span>
              <span class="head_item">Del</span>
            </div>

            <div class="the_row"  *ngFor="let areaofimpactitem of areaofimpactedFormArray.get('AreaOfImpacts')['controls']; index as i"
            (click)="onEdit(i, areaofimpactitem.value)" style="cursor: pointer;"
            matTooltip="Click to edit"
              aria-label="Button that displays a tooltip when focused or hovered over">
              <span class="row_data">{{i + 1}}</span>
              <span class="row_data">{{getPartyName(areaofimpactitem.value.PartyId)}}</span>
              <span class="row_data">{{getTerrainName(areaofimpactitem.value.TerrainId)}}</span>
              <span class="row_data">{{areaofimpactitem.value.Area}}</span>
              <span class="row_data">{{getUOMName(areaofimpactitem.value.UomId)}}</span>
              <span class="row_data">{{areaofimpactitem.value.Remarks}}</span>
              <span class="row_data" (click)="$event.stopImmediatePropagation()">
                  <button
                  class="delete_icon trash"
        
                  (click)="deleteAreaOfImpact(i, areaofimpactitem.value)">
                  <em class="ti-trash"> </em> </button>
                </span>
             
            </div>

           
          </div>

          <div class="btn_holder" *ngIf="listView">
            <button class="default_primary-button" (click)="onSubmit()">Submit</button>
        </div>
       
        </div>
       
        <div class="entry_values"  *ngIf="gridView">
            <div class="entry" *ngFor="let areaofimpactitem of areaofimpactedFormArray.get('AreaOfImpacts')['controls']; index as i"
            (click)="onEdit(i, areaofimpactitem.value)" style="cursor: pointer;"
            matTooltip="Click to edit"
              aria-label="Button that displays a tooltip when focused or hovered over">
              <h1 class="section_name">
              
                <p class="other_item"> Party Name: <span class="row_data">{{getPartyName(areaofimpactitem.value.PartyId)}}</span>
                <em class="ti-trash"  ((click)="deleteAreaOfImpact(i, areaofimpactitem.value)"></em> 
                <em class="ti-pencil-o"  (click)="onEdit(i, areaofimpactitem.value)"></em> 
              </p>
              </h1>
        
              <div class="location">
                <!-- <p class="other_item">State Name: <span class="file_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="StateName"></span></p>
                <p class="other_item">Lga Name: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="LgaName"></span></p>
                <p class="other_item">Community Name: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="CommunityName"></span></p>
                <p class="other_item">Remarks: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="Remarks"></span></p>
                -->
                <!-- <p class="other_item"> State Name: <span class="row_data">{{getStateName(impactcommitem.value.ImpactedStateId)}}</span></p>
                  <p class="other_item"> Lga Name: <span class="row_data">{{getLgaName(impactcommitem.value.ImpactedLGAId)}}</span></p>
                    <p class="other_item"> Community Name: <span class="row_data">{{getCommunityName(impactcommitem.value.ImpactedCommunityId)}}</span></p>
                      <p class="other_item"> Remarks: <span class="row_data">{{impactcommitem.value.Remarks}}</span></p>
              -->
                     
                      <p class="other_item"> <span class="row_data">Terrain: {{getTerrainName(areaofimpactitem.value.TerrainId)}}</span></p>
                        <p class="other_item"><span class="row_data">Area: {{areaofimpactitem.value.Area}}</span></p>
                          <p class="other_item"><span class="row_data">Unit of Measurement: {{getUOMName(areaofimpactitem.value.UomId)}}</span></p>
                            <p class="other_item"><span class="row_data">Remarks: {{areaofimpactitem.value.Remarks}}</span> </p>
             
                    </div>
            </div>
            <div class="btn_holder">
                <button  class="default_primary-button"  (click)="onSubmit()" >
           
                    Save  &rarr;
                 
                </button>
             </div>
          </div>

      </div>
    
    
  </div>
</form>